import { createFileRoute } from '@tanstack/react-router';

import { CommitteeBrowse } from '@/module/Author/Committee';

export const Route = createFileRoute('/_auth/author/_author/committee/_committee/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CommitteeBrowse />;
}
